import { AccountOptionType } from "../../types/types";
import { ClusterOptionType } from "../../../../../pages/kubernetes-live-usage-mgmt/components/navigation/selected-cluster/components/utils/types";

export const sortByAlphanumericForAccountOptionType = (
  options: AccountOptionType[] | ClusterOptionType[],
) => {
  return [...options].sort((a, b) => {
    let current = a.label;
    let next = b.label;

    if (!current || !next) {
      return 0;
    }

    current = current.toLowerCase();
    next = next.toLowerCase();

    if (current < next) {
      return -1;
    }

    if (current > next) {
      return 1;
    }

    return 0;
  });
};
